import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SewMarkdown } from '@sew/ui-components-angular/standalone';
import { Content } from '../../../../models/blog-posts.model';
import { ReplaceLinebreakPipe } from '../../../../pipes/replace-linebreak/replace-linebreak.pipe';

@Component({
    selector: 'blog-highlight',
    templateUrl: './highlight.component.html',
    styleUrls: ['./highlight.component.scss'],
    imports: [CommonModule, ReplaceLinebreakPipe, SewMarkdown],
})
export class HighlightComponent {
    @Input() public highlight?: Content;
}
